import { Injectable } from '@angular/core';

@Injectable()
export class Constants {
    VERSION_NUMBER: string = 'v 4.5';
    BUILD_NUMBER: string = '14413084';
    HAZARD_TEMPLATE_ID = '838364630460447047927402374';
    ACTION_TEMPLATE_ID = 'fh_task_template:action';
}



// WEBPACK FOOTER //
// ./src/app/constants.ts